<template>
  <div class="modal">
    <div class="modal__content">
      <p>{{ this.modalMessage }}</p>
      <button @click="closeModal">أغلق</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: ["modalMessage"],
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style lang="scss">
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.65);
  .modal__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    width: 300px;
    padding: 40px 30px;
    background-color: #fff;
    p {
      text-align: center;
    }
    button {
      align-self: center;
      padding: 7px 20px;
      font-size: 15px;
    }
  }
}
</style>
